import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner OutsourcingBack">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">Professional digital marketing </h2>
						<div className="red-border"> </div>
						<p> Service that derive results </p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
